import React from 'react';
import classnames from 'classnames';

import styles from './modal-footer.css';

interface ModalFooterProps {
  /** Align children right or left */
  layout?: 'right' | 'left';
  /** Footer elements for the modal */
  children?: React.ReactNode;
  /** custom class names */
  className?: string;
  /** Provides a data-testid */
  'data-testid'?: string;
}

/**
 * Modal Footer component
 *
 * @param {ModalFooterProps} param
 *
 * @returns JSX.ELEMENT
 */
export const ModalFooter = ({
  children,
  className,
  'data-testid': dataTestId,
  layout = 'right'
}: ModalFooterProps) => (
  <footer
    className={classnames([styles.footer, styles[layout], className])}
    data-testid={dataTestId}
  >
    {children}
  </footer>
);

export default ModalFooter;
